module.exports = __webpack_public_path__ + "static/media/ghosttemplate.a8195ae7.png";